/**
* DevExpress Dashboard (_helpers.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var _helpers_1 = require("../model/data-item/_helpers");
var _data_source_browser_1 = require("./_data-source-browser");
function getDimensionsExpressions(dashboardItem, dataFieldProvider) {
    var deferred = $.Deferred();
    var fieldsNames = dashboardItem._dimensions.map(function (d) { return d.dataMember(); });
    _data_source_browser_1.getDataFields(fieldsNames, dashboardItem.dataSource(), dashboardItem.dataMember(), dataFieldProvider)
        .done(function (fields) {
        var dimensionsExpressions = {};
        dashboardItem._dimensions.map(function (dim) {
            var field = fields.filter(function (f) { return f.dataMember() === dim.dataMember(); })[0];
            dimensionsExpressions[dim.uniqueName()] = _helpers_1.getDimensionExpression(dim.dataMember(), dim.dateTimeGroupInterval(), dim.textGroupInterval(), field.fieldType());
        });
        deferred.resolve(dimensionsExpressions);
    });
    return deferred.promise();
}
exports.getDimensionsExpressions = getDimensionsExpressions;
